<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            :main-title="this.$t('press.section1.texts.text1-1')"
            :sub-title="this.$t('press.section1.texts.text1-2')"
            bg-color=""
        />

        <!-- ANCHOR: 테이블 -->
        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        lg="8"
                        md="10"
                        sm="12"
                    >
                        <template v-if="getPressList.length > 0">
                            <v-simple-table class="le-simple-table">
                                <template v-slot:default>
                                    <tbody>
                                        <tr
                                            v-for="item in getPressList"
                                            :key="item.id"
                                            @click="goToPressLink(item.linkUrl)"
                                        >
                                            <td>
                                                <div>
                                                    <div class="d-flex flex-column gap-3">
                                                        <div class="d-flex align-center">
                                                            <v-icon
                                                                size="32"
                                                                color="blue10"
                                                                class="mr-2"
                                                            >
                                                                fontagon-icons ft-icon ft-ic_newsPaper_fill
                                                            </v-icon>

                                                            <span class="le-text-body3">{{ item.publisher }}</span>
                                                        </div>
                                            
                                                        <div class="le-text-subtitle3 truncate-two-lines">
                                                            {{ item.title }}
                                                        </div>

                                                        <div class="le-text-body3">
                                                            {{ item.publishedDate.split('T')[0] }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>

                        <template v-else>
                            <div class="d-flex justify-center">
                                <v-progress-circular
                                    indeterminate
                                    color="#FF6442"
                                    size="60"
                                    width="10"
                                ></v-progress-circular>
                            </div>
                        </template>
                    </v-col>
                </v-row>
            </div>
        </section>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { getPressMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'PressPage',
    components: {
        PageTitle
    },

    // metaInfo() {
    //     return getPressMetaInfo(this);
    // },

    // SECTION: Data Properties
    data: function () {
        return {
            //
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    computed: {
        ...mapGetters('press', ['getPressList']),
    },

    created() {
        //
    },

    mounted() {
        this.fetchPressList();
    },

    beforeDestroy() {
        //
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        ...mapActions(
            'press', [ 'fetchPressList' ]
        ),

        /* ============================================================
         * ANCHOR: 주석
         * ============================================================ */
        goToPressLink(link) {
            window.open(link, '_blank');
        },
    },
    // !SECTION: Methods
};
</script>
